<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_25189_11820" fill="white">
      <rect
        x="0.888916"
        y="3.55566"
        width="3.55556"
        height="11.5556"
        rx="1"
      />
    </mask>
    <rect
      x="0.888916"
      y="3.55566"
      width="3.55556"
      height="11.5556"
      rx="1"
      stroke="#2B303A"
      stroke-width="2.8"
      mask="url(#path-1-inside-1_25189_11820)"
    />
    <mask id="path-2-inside-2_25189_11820" fill="white">
      <rect
        x="6.22217"
        y="6.22217"
        width="3.55556"
        height="8.88889"
        rx="1"
      />
    </mask>
    <rect
      x="6.22217"
      y="6.22217"
      width="3.55556"
      height="8.88889"
      rx="1"
      stroke="#2B303A"
      stroke-width="2.8"
      mask="url(#path-2-inside-2_25189_11820)"
    />
    <mask id="path-3-inside-3_25189_11820" fill="white">
      <rect
        x="11.5555"
        y="0.888672"
        width="3.55556"
        height="14.2222"
        rx="1"
      />
    </mask>
    <rect
      x="11.5555"
      y="0.888672"
      width="3.55556"
      height="14.2222"
      rx="1"
      stroke="#2B303A"
      stroke-width="2.8"
      mask="url(#path-3-inside-3_25189_11820)"
    />
  </svg>
</template>

